import { BuildStateEnum } from "@/__generated__/graphql";
import BadgeDot from "@/components/shared/BadgeDot";
import StateBadge from "@/components/StateBadges/StateBadge";

export default function BuildStateBadge({ state }: { state?: BuildStateEnum }) {
  if (typeof state === "undefined") return null;

  function badgeDotForState(state: BuildStateEnum) {
    switch (state) {
      case BuildStateEnum.Ready:
      case BuildStateEnum.Waiting:
      case BuildStateEnum.Running:
        return <BadgeDot variant="yellow" />;
      case BuildStateEnum.Done:
        return <BadgeDot variant="green" />;
      case BuildStateEnum.Errored:
        return <BadgeDot variant="red" />;
      case BuildStateEnum.Canceled:
        return <BadgeDot variant="gray" />;
    }
  }

  return (
    <StateBadge
      badgeDot={badgeDotForState(state)}
      spinnerVisibleOnStates={[BuildStateEnum.Ready, BuildStateEnum.Waiting, BuildStateEnum.Running]}
      state={state}
    />
  );
}
